import { render, staticRenderFns } from "./MenuItemCategories.vue?vue&type=template&id=1b7ca742&"
import script from "./MenuItemCategories.vue?vue&type=script&lang=js&"
export * from "./MenuItemCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports